module.exports = __webpack_public_path__ + "static/img/1.3c536f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/pengu/1.png
// module id = 3kfN
// module chunks = 35